import { Component, Input } from '@angular/core';

/**
 * Cabecera de pantalla: título, subtítulo y zona de acciones.
 *
 * Extraído de `shop-settings/shop-info`, que es la referencia de diseño del backoffice. El
 * markup estaba copiado a mano en las 8 pantallas de shop-settings; la base tipográfica y de
 * layout era byte a byte idéntica en las 8, así que unificarla no cambia nada.
 *
 * Las acciones van por PROYECCIÓN y no por `@Input`, a propósito: cada pantalla pone un botón
 * distinto (primario u outline, con `*ngIf`, con `[disabled]` calculado, con iconos distintos).
 * Tiparlo habría acabado en un `any[]` de configuración; proyectando, cada pantalla se queda su
 * botón tal cual lo tiene hoy.
 *
 *   <app-page-header title="sh_setting_info" subtitle="sh_setting_info_desc">
 *     <div page-header-actions>
 *       <button class="btn btn-primary" ...>...</button>
 *     </div>
 *   </app-page-header>
 *
 * Los textos son CLAVES i18n: el componente aplica el pipe. Es lo que hacen ya todas las
 * pantallas, y si la clave no existe `translate` devuelve la propia clave, que es la vía de
 * escape para texto crudo.
 */
@Component({
  selector: 'app-page-header',
  templateUrl: './page-header.component.html',
  styleUrls: ['./page-header.component.scss']
})
export class PageHeaderComponent {

  /** Clave i18n del título. */
  @Input() title!: string;

  /** Clave i18n del subtítulo. Si no se pasa, no se pinta el párrafo. */
  @Input() subtitle?: string;

  /** Parámetros de interpolación, por si el texto lleva {{...}}. */
  @Input() titleParams?: Record<string, unknown>;
  @Input() subtitleParams?: Record<string, unknown>;

  /**
   * En móvil, estirar los botones a todo el ancho.
   *
   * Por defecto NO, que es el comportamiento de 5 de las 8 pantallas. `shop-info` es la única
   * que hoy los estira, así que es la única que tendrá que activarlo cuando se migre. Se expone
   * como opción en vez de imponer una de las dos para no cambiar ni un píxel en ninguna.
   */
  @Input() fullWidthActionsOnMobile = false;
}
